import Vue from 'vue';

import _ from "lodash";

let albums = {
      state: {
        list:[],
        loaded:false
      },
      mutations:{

      },
      actions:{
          loadAlbums({  state }){
              //state.list = require("../assets/json/photos.json")
              Vue.http.get("content/photos").then((res) => {
                  state.list = _(state.list) // start sequence
                    .keyBy('_id') // create a dictionary of the 1st array
                    .merge(_.keyBy(res.body.photos, '_id')) 
                    .values().value()
              });
          }
      }
  };
  export default albums;